"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagItemSuggestion = exports.TagItemSuggestionBase = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../../Utilities");
var TagItemSuggestion_styles_1 = require("./TagItemSuggestion.styles");
var getClassNames = (0, Utilities_1.classNamesFunction)();
/**
 * {@docCategory TagPicker}
 */
// eslint-disable-next-line @typescript-eslint/no-deprecated
var TagItemSuggestionBase = function (props) {
    var styles = props.styles, theme = props.theme, children = props.children, rest = tslib_1.__rest(props, ["styles", "theme", "children"]);
    var classNames = getClassNames(styles, {
        theme: theme,
    });
    return (React.createElement("div", tslib_1.__assign({ className: classNames.suggestionTextOverflow }, rest),
        ' ',
        children,
        ' '));
};
exports.TagItemSuggestionBase = TagItemSuggestionBase;
exports.TagItemSuggestion = (0, Utilities_1.styled)(exports.TagItemSuggestionBase, TagItemSuggestion_styles_1.getStyles, undefined, { scope: 'TagItemSuggestion' });
//# sourceMappingURL=TagItemSuggestion.js.map